import {DetailField} from "../../../shared/models";
import {Cultivo} from "./cultivos.model";

export const CULTIVOSSECANODETAIL_DEFAULT_FIELDS: DetailField[] = [
  {name: 'cultivoNombre', label: 'Cultivo'}
];

export interface CultivosSecanoDetailParams {
  cultivo: Cultivo;
  fields?: DetailField[];
}
